/* eslint-disable react-hooks/exhaustive-deps */
import { SearchOutlined } from '@ant-design/icons';
import { Input, Pagination, Spin, Table } from 'antd';
import classNames from 'classnames';
import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import DayLeftToolTip from '../../../components/Shared/tooltip/dayleft';
import ConsentService from '../../../services/Consent.service';
import { getTagAction, getTagDay } from '../../../util/util';
import { ROUTER } from '../../../constants/router';
import usePermission from '../../../hooks/usePermission';

const Manage = () => {
    const { t } = useTranslation();
    const [identity, setIdentity] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageValue, setPageValue] = useState({
        p: 1,
        ps: 10,
        total: 0,
    });

    const getConsentCountIdentity = async (identity, p, ps) => {
        const params = { p, ps, identity };
        setLoading(true);
        try {
            const { data } = await ConsentService.getConsentCountIdentity(
                params
            );
            const result = data.resultData;
            if (result) {
                setIdentity(result.result);
                const pageValue = {
                    p: result.page,
                    ps: result.pageSize,
                    total: result.total,
                };
                setPageValue(pageValue);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        getConsentCountIdentity(null, 1, 10);
    }, []);

    const searchIdentity = (value) => {
        getConsentCountIdentity(value, 1, 10);
    };

    const onChange = (page, pageSize) => {
        getConsentCountIdentity('', page, pageSize);
    };

    return (
        <div className="mt-6">
            <div className="grid grid-cols-2 card">
                <div>
                    <div className="font-medium text-xl">
                        {t('Search Filter')}
                    </div>
                    <Input
                        size="large"
                        placeholder={t('Consent.SearchIdentity')}
                        className="mt-2"
                        prefix={<SearchOutlined />}
                        onChange={(e) => searchIdentity(e.target.value)}
                    />
                </div>
                <div className="flex justify-end">
                    <DayLeftToolTip />
                </div>
            </div>
            <div className="text-[#65707A] font-semibold my-4">
                {t('TotalItems', { length: pageValue.total })}
            </div>
            <div className="h-[60vh] overflow-y-auto mb-6">
                <Spin spinning={loading}>
                    <div className="space-y-4">
                        {identity?.map((item, index) => (
                            <Identity key={index} item={item} />
                        ))}
                    </div>
                </Spin>
            </div>
            <div className="flex justify-end">
                <Pagination
                    current={pageValue.p}
                    onChange={onChange}
                    pageSize={pageValue.ps}
                    total={pageValue.total}
                />
            </div>
        </div>
    );
};

const Identity = ({ item }) => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const { isAuditor } = usePermission();

    return (
        <div className="card">
            <div
                className="flex items-center justify-between pb-4"
                style={{ borderBottom: '1px solid #EDEEF9' }}
            >
                {isAuditor ? (
                    <div className="text-purple flex space-x-2 font-semibold text-base">
                        <span>{t('Consent.Identity')} : </span>
                        <span>{item?.identity ?? '-'}</span>
                    </div>
                ) : (
                    <Link
                        to={`${ROUTER.CONSENT_MANAGEMENT.MANANGE_CONSENT}/${item?.identity}`}
                        className="text-purple flex space-x-2 font-semibold text-base"
                    >
                        <span>{t('Consent.Identity')} : </span>
                        <span>{item?.identity ?? '-'}</span>
                    </Link>
                )}
                {!isAuditor && (
                    <IconEye
                        className="cursor-pointer"
                        onClick={() => {
                            navigate(
                                `${ROUTER.CONSENT_MANAGEMENT.MANANGE_CONSENT}/${item?.identity}`
                            );
                        }}
                    />
                )}
            </div>
            {open && <Consent identity={item?.identity} />}
            <button
                onClick={() => setOpen(!open)}
                className="pt-4 w-full flex items-center justify-center text-[#1890FF]"
            >
                <span className="mr-2">
                    <svg
                        className={classNames(
                            { 'rotate-180': open },
                            'transition-all duration-300'
                        )}
                        width="12"
                        height="11"
                        viewBox="0 0 12 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M11.8629 4.13606C11.9064 4.17852 11.9409 4.22927 11.9645 4.28529C11.988 4.34132 12.0001 4.4015 12 4.46227C11.9999 4.52305 11.9876 4.58318 11.9639 4.63914C11.9402 4.69509 11.9055 4.74573 11.8619 4.78806L6.54492 9.97007C6.45155 10.0611 6.32632 10.112 6.19592 10.112C6.06553 10.112 5.9403 10.0611 5.84692 9.97007L0.529938 4.78806C0.486395 4.74566 0.451786 4.69497 0.428155 4.63898C0.404524 4.58299 0.392349 4.52283 0.392349 4.46206C0.392349 4.40128 0.404524 4.34113 0.428155 4.28514C0.451786 4.22914 0.486395 4.17846 0.529939 4.13606C0.619236 4.04884 0.739111 4.00001 0.863938 4.00001C0.988765 4.00001 1.10864 4.04884 1.19794 4.13606L6.19592 9.00907L11.1959 4.13606C11.2852 4.04914 11.4048 4.00049 11.5294 4.00049C11.654 4.00049 11.7737 4.04914 11.8629 4.13606ZM11.8629 0.136053C11.9064 0.178516 11.9409 0.229259 11.9645 0.285286C11.988 0.341314 12.0001 0.40149 12 0.462264C11.9999 0.523038 11.9876 0.583178 11.9639 0.639133C11.9402 0.695088 11.9055 0.745724 11.8619 0.788054L6.54492 5.97006C6.45155 6.06108 6.32632 6.11201 6.19592 6.11201C6.06553 6.11201 5.9403 6.06108 5.84692 5.97006L0.529939 0.788053C0.486395 0.745657 0.451786 0.694967 0.428155 0.638976C0.404524 0.582985 0.392349 0.522827 0.392349 0.462053C0.392349 0.401279 0.404524 0.341121 0.428155 0.285129C0.451786 0.229138 0.486395 0.178448 0.529939 0.136052C0.619236 0.0488298 0.739111 -4.92229e-07 0.863938 -4.86773e-07C0.988765 -4.81316e-07 1.10864 0.0488298 1.19794 0.136052L6.19592 5.00906L11.1959 0.136053C11.2852 0.0491295 11.4048 0.000487541 11.5294 0.000487546C11.654 0.000487552 11.7737 0.0491295 11.8629 0.136053Z"
                            fill="#1890FF"
                        />
                    </svg>
                </span>
                {!open ? 'Expand Consent Info' : 'Collapse Consent Info'}
            </button>
        </div>
    );
};

const Consent = ({ identity }) => {
    const { t, i18n } = useTranslation();
    const columns = [
        {
            title: t('Consent.ConsentName'),
            dataIndex:
                i18n.language === 'en' ? 'consentNameEn' : 'consentNameTh',
            key: i18n.language === 'en' ? 'consentNameEn' : 'consentNameTh',
            render: (text) => (text ? text : '-'),
        },
        {
            title: t('Consent.DayLeft'),
            dataIndex: 'dayLeft',
            key: 'dayLeft',
            align: 'center',
            render: (text) => getTagDay(text),
        },
        {
            title: t('Consent.ConsentDate'),
            dataIndex: 'consentDate',
            key: 'consentDate',
            align: 'center',
        },
        {
            title: t('Consent.Status'),
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            render: (status) => getTagAction(status),
        },
        {
            title: t('Consent.CollectionPointName'),
            dataIndex: 'collectionPointName',
            key: 'collectionPointName',
            render: (text) => (text ? text : '-'),
            className: 'min-w-[200px]',
        },
        {
            title: t('Consent.UpdateBy'),
            dataIndex: 'updateBy',
            key: 'updateBy',
        },
        {
            title: t('Consent.AcceptedVersion'),
            dataIndex: 'acceptedVersion',
            key: 'acceptedVersion',
        },

        {
            title: t('Consent.UsageStatus'),
            dataIndex: 'usageStatus',
            key: 'usageStatus',
            render: (text, record) => {
                return (
                    <div className="space-y-1">
                        <div>{text}</div>
                        {record.newVersion && (
                            <div className="text-xs px-2 rounded-2xl bg-purple w-max text-white">
                                {t('Consent.NewVersion')}
                            </div>
                        )}
                        {record.isExpire && (
                            <div className="text-xs px-2 rounded-2xl bg-purple w-max text-white">
                                {t('Consent.Expired')}
                            </div>
                        )}
                    </div>
                );
            },
        },
    ];

    const [result, setResult] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState();

    useEffect(() => {
        setLoading(true);
        const searchManageConsent = async () => {
            try {
                const params = {
                    identity,
                };
                const { data } = await ConsentService.searchManageConsent(
                    params
                );
                if (data.resultData.result) {
                    setResult(data.resultData.result);
                    setTotal(data?.resultData?.total);
                    setLoading(false);
                } else {
                    setResult([]);
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
                console.log(error);
            }
        };
        if (identity) searchManageConsent();
    }, [identity]);
    return (
        <>
            <div
                className="text-base font-semibold py-4"
                style={{ borderBottom: '1px solid #EDEEF9' }}
            >
                Total ({total ?? 0})
            </div>
            <Table
                loading={loading}
                rowKey={(record) => record.consentTxnGroupId}
                className="inbox_table"
                dataSource={result}
                columns={columns}
                pagination={false}
                scroll={{
                    y: 252,
                }}
            />
        </>
    );
};

const IconEye = (props) => {
    return (
        <svg
            {...props}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="32" height="32" rx="6" fill="#F3F6F9" />
            <path
                d="M16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z"
                fill="#7B67FB"
            />
            <path
                d="M23.4698 15.83C22.8817 14.3088 21.8608 12.9933 20.5332 12.046C19.2056 11.0988 17.6295 10.5613 15.9998 10.5C14.37 10.5613 12.794 11.0988 11.4664 12.046C10.1388 12.9933 9.11787 14.3088 8.52979 15.83C8.49007 15.9399 8.49007 16.0601 8.52979 16.17C9.11787 17.6912 10.1388 19.0067 11.4664 19.954C12.794 20.9012 14.37 21.4387 15.9998 21.5C17.6295 21.4387 19.2056 20.9012 20.5332 19.954C21.8608 19.0067 22.8817 17.6912 23.4698 16.17C23.5095 16.0601 23.5095 15.9399 23.4698 15.83V15.83ZM15.9998 19.25C15.357 19.25 14.7286 19.0594 14.1942 18.7023C13.6597 18.3452 13.2432 17.8376 12.9972 17.2437C12.7512 16.6499 12.6868 15.9964 12.8122 15.366C12.9376 14.7355 13.2472 14.1564 13.7017 13.7019C14.1562 13.2474 14.7353 12.9378 15.3657 12.8124C15.9962 12.687 16.6496 12.7514 17.2435 12.9974C17.8374 13.2434 18.3449 13.6599 18.7021 14.1944C19.0592 14.7289 19.2498 15.3572 19.2498 16C19.2485 16.8615 18.9056 17.6874 18.2964 18.2966C17.6872 18.9058 16.8613 19.2487 15.9998 19.25V19.25Z"
                fill="#7B67FB"
            />
        </svg>
    );
};

export default Manage;
